import Layout from "@/components/feature/Layout";
import { usePageMeta, SITE_ORIGIN } from "@/hooks/usePageMeta";
import { caseArticles } from "@/mocks/cases";
import { faqs, siteInfo } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import IssuesSection from "@/pages/home/components/IssuesSection";
import StatsSection from "@/pages/home/components/StatsSection";
import HotCasesSection from "@/pages/home/components/HotCasesSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import MethodSection from "@/pages/home/components/MethodSection";
import VoicesSection from "@/pages/home/components/VoicesSection";
import FaqSection from "@/pages/home/components/FaqSection";
import ContactCtaSection from "@/pages/home/components/ContactCtaSection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_ORIGIN}/#organization`,
      name: siteInfo.name,
      url: SITE_ORIGIN,
      description: siteInfo.description,
      email: siteInfo.email,
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_ORIGIN}/#website`,
      url: SITE_ORIGIN,
      name: siteInfo.name,
      inLanguage: "zh-CN",
      publisher: { "@id": `${SITE_ORIGIN}/#organization` },
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_ORIGIN}/cases?keyword={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_ORIGIN}/#webpage`,
      url: SITE_ORIGIN,
      name: `${siteInfo.name}｜网暴黑料调查与舆论解剖`,
      description: siteInfo.description,
      isPartOf: { "@id": `${SITE_ORIGIN}/#website` },
      inLanguage: "zh-CN",
    },
    {
      "@type": "ItemList",
      name: "重点调查档案",
      itemListElement: caseArticles.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${SITE_ORIGIN}/cases/${item.slug}`,
        name: item.title,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.slice(0, 6).map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  usePageMeta({
    title: "网暴黑料调查｜起底施暴者动机、键盘侠与水军组织 - 黑料显微镜",
    description:
      "黑料显微镜专注网暴黑料深度调查，起底施暴者真实动机，拆解键盘侠心理、水军组织手法与舆论操纵产业链。看懂谁在刷屏、谁在借刀杀人、谁在靠网暴牟利，并提供取证与维权指南。",
    keywords: "网暴黑料,网暴黑料施暴者,网暴黑料键盘侠,网暴黑料动机,网暴黑料水军,舆论操纵",
    path: "/",
    jsonLd: homeJsonLd,
  });

  return (
    <Layout transparentNav>
      <HeroSection />
      <IssuesSection />
      <StatsSection />
      <HotCasesSection />
      <TopicsSection />
      <MethodSection />
      <VoicesSection />
      <FaqSection />
      <ContactCtaSection />
    </Layout>
  );
}